export const ERR_GENERIC = 'Une erreur est survenue.';
export const ERR_GENERIC_ORDER_DETAILS = `Cette information n'est pas disponible actuellement.`;
export const ERR_NOT_FOUND = 'Cet article n’est plus disponible.';
export const TXT_BACK = 'Retour';
